"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var noScrollClass = 't-no-scroll';

function _default(TargetClass) {
  var onMount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _TargetClass$prototyp = TargetClass.prototype,
      _componentDidMount = _TargetClass$prototyp.componentDidMount,
      _componentWillUnmount = _TargetClass$prototyp.componentWillUnmount;
  Object.assign(TargetClass.prototype, {
    componentDidMount: function componentDidMount() {
      if (_componentDidMount) {
        _componentDidMount.call(this);
      }

      if (onMount) {
        this.addStyle();
      }
    },
    componentWillUnmount: function componentWillUnmount() {
      if (_componentWillUnmount) {
        _componentWillUnmount.call(this);
      }

      this.removeStyle();
    },
    removeStyle: function removeStyle() {
      var styleTags = document.getElementsByClassName(noScrollClass);

      for (var i = 0; i < styleTags.length; i++) {
        var element = styleTags[i];
        element && element.remove();
      }
    },
    addStyle: function addStyle() {
      if (document.getElementsByClassName(noScrollClass).length) {
        return;
      }

      var styleTag = document.createElement('style');
      styleTag.setAttribute('class', noScrollClass);
      document.head.appendChild(styleTag);
      styleTag.innerHTML = "body {\n        padding-right: 15px !important;\n        overflow: hidden !important;\n      }";
    }
  });
  return TargetClass;
}